// extracted by mini-css-extract-plugin
module.exports =  {"main":"card-module_main_ef39a"};